<kodit-dropdown
  [options]="groupedItems"
  [formCtrl]="formCtrl"
  [isGrouped]="true"
  [ctrlDisabled]="disabled"
  (optionChanged)="handleOnItemChange($event)"
></kodit-dropdown>
